<h2 mat-dialog-title>{{data?.title || 'Confirmation'}}</h2>
<mat-dialog-content>{{data?.msg || 'Are you sure?'}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button color="warn" [mat-dialog-close]="true">{{data?.confirmLabel || 'Yes'}}</button>
</mat-dialog-actions>
